module.exports = "<div class=\"wrapper\">\r\n    <div id=\"calculator-container\">\r\n\r\n        <div id=\"col-content-wrapper\">\r\n            <tpc-calculator-item></tpc-calculator-item>\r\n        </div>\r\n\r\n        <div id=\"col-summary\" data-region=\"summary\">\r\n            <tpc-dashboard></tpc-dashboard>\r\n        </div>\r\n    </div>\r\n    <tpc-spinner></tpc-spinner>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator.component.html
// module id = ./src/app/components/calculator/calculator.component.html
// module chunks = main